import {estimateStatuses} from "../EstimateState";

export const OrderCompositionTableFilterData = [
    {
        "idFromColumnFilter": "customerName",
        "id": "customerName",
    },

    {
        "idFromColumnFilter": "numberCustomer",
        "id": "numberCustomer",
        "filterFn": (value, filterValue) => value === null ? "не занумерован".includes(filterValue.toLowerCase()) : value.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "dateOfPerformance",
        "id": "dateOfPerformance",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },

    {
        "idFromColumnFilter": "dateOfCreate",
        "id": "dateOfCreate",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "estimateState",
        "id": "estimate",
        "field": "estimateState",
        "filterFn": (value, filterValue) => (estimateStatuses[value] ?? 'Формирование композиции').toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "calculationTotalCostBasePrice",
        "id": "estimate",
        "field": "calculationTotalCostBasePrice",
        "filterFn": (value, filterValue) => !value ? "ожидание".includes(filterValue.toLowerCase()) : value.toString()?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "baseTotalPrice",
        "id": "estimate",
        "field": "baseTotalPrice",
        "filterFn": (value, filterValue) => !value ? "ожидание".includes(filterValue.toLowerCase()) : value.toString()?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {

        "idFromColumnFilter": "profitCalculationBaseTotalPrice",
        "id": "estimate",
        "field": "profitCalculationBaseTotalPrice",
        "filterFn": (value, filterValue) => !value ? "ожидание".includes(filterValue.toLowerCase()) : value.toString()?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "calculationGrossMargin",
        "id": "estimate",
        "field": "calculationGrossMargin",
        "filterFn": (value, filterValue) => !value ? "ожидание".includes(filterValue.toLowerCase()) : value.toString()?.toLowerCase().includes(filterValue.toLowerCase())
    },
]
